import {createAction} from "redux-act";
import {IDictionary, ISubscribeToChecksums} from "modules/types";

export const fetchChecksumsJSON = createAction();
export const fetchChecksumsJSONSuccess = createAction<IDictionary<unknown>>();
export const fetchChecksumsJSONFailed = createAction<Error>();

export const subscribeToLiveScores = createAction<ISubscribeToChecksums>();
export const unsubscribeFromLiveScores = createAction();
